import Api from "./index";

export const AdminLogin = (credentials) => {
  return Api().post("login/admin/verify", credentials);
};

export const AddNewPlayer = (credentials, config) => {
  return Api().post("admin/create/player", credentials, config);
};
export const ViewPlayers = (headers) => {
  return Api().post("admin/view/players", {}, headers);
};
export const GetPlayers = (headers) => {
  return Api().get("admin/get/players", headers);
};
export const EditPlayerDetails = (credentials, headers) => {
  return Api().post("admin/edit/player", credentials, headers);
};
export const AddNewCoach = (formData, config) => {
  return Api().post("admin/create/coach", formData, config);
};
export const ViewCoachesDet = (headers) => {
  return Api().post("admin/view/coaches", {}, headers);
};
export const EditCoachDetails = (credentials, headers) => {
  return Api().post("admin/edit/coach", credentials, headers);
};
export const DeleteCoach = (deleteData) => {
  return Api().delete("admin/delete/coach", deleteData);
};

export const AddNewSponsors = (formData, config) => {
  return Api().post("admin/create/sponsors", formData, config);
};
export const ViewSponsorsDet = (headers) => {
  return Api().get("admin/view/sponsors", headers);
};
export const DeleteSponsors = (deleteData) => {
  return Api().delete("admin/delete/sponsors", deleteData);
};
// export const CoachUpload = (formData, config) => {
//   return Api().post("admin/coach/upload", formData, config);
// };
// Home
export const AddNewAchievement = (formData, config) => {
  return Api().post("admin/create/achievement", formData, config);
};
export const ViewAchievementsDet = (headers) => {
  return Api().get("admin/view/achievements", headers);
};
export const EditAchievementDet = (formData, config) => {
  return Api().post("admin/edit/achievements", formData, config);
};
export const DeleteAchievements = (deleteData) => {
  return Api().delete("admin/delete/achievements", deleteData);
};

export const AddNewSchedule = (formData, config) => {
  return Api().post("admin/create/schedules", formData, config);
};
export const ViewSchedulesDet = (headers) => {
  return Api().get("admin/view/schedules", headers);
};
export const EditScheduleDet = (formData, config) => {
  return Api().post("admin/edit/schedules", formData, config);
};
export const DeleteSchedule = (deleteData) => {
  return Api().delete("admin/delete/schedule", deleteData);
};

export const AddNewTrainings = (formData, config) => {
  return Api().post("admin/create/trainings", formData, config);
};
export const ViewTrainingsDet = (headers) => {
  return Api().get("admin/view/trainings", headers);
};
export const EditTrainingsDet = (formData, config) => {
  return Api().post("admin/edit/trainings", formData, config);
};

export const DeleteTraining = (deleteData) => {
  return Api().delete("admin/delete/training", deleteData);
};

export const getCoachHome = () => {
  return Api().get("home/getcoaches");
};
export const getAchievementsPage = () => {
  return Api().get("home/getachievements");
};
export const getSchedulesPage = () => {
  return Api().get("home/getschedules");
};

export const getTrainingsPage = () => {
  return Api().get("home/gettrainings");
};

export const getSponsorsPage = () => {
  return Api().get("home/getsponsors");
};

export const sendCommentEmail = (data) => {
  return Api().post("home/sendcomment",data);
};
